import { render, staticRenderFns } from "./LegalDocumentMessagesDetailsBox.vue?vue&type=template&id=3773d6ae&scoped=true&"
import script from "./LegalDocumentMessagesDetailsBox.vue?vue&type=script&lang=js&"
export * from "./LegalDocumentMessagesDetailsBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3773d6ae",
  null
  
)

export default component.exports